import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainBackgroundImage: {
    width: '100%',
    marginTop: ['25ox', '67px'],
    paddingBottom: ['25px', '55px'],
  },
  title: {
    marginBottom: [null, '20px'],
    color: 'white',
  },
  videoContainer: {
    margin: '0px auto',
    '@media screen and (min-width: 768px)': {
      width: '560px',
      height: '354px',
    },
    width: ['257px', '612px', '680px', '748px', '831px'],
    height: ['162px', '387px', '430px', '473px', '525px'],
    backgroundColor: 'black.100',
    '*': {
      outline: 'none !important',
    },
  },
  outOfBounds: {
    marginTop: ['-25px', '-67px'],
  },
  youtubeVideoContainer: {
    position: 'relative',

    iframe: {
      height: '100%',
      left: '0',
      position: 'absolute',
      top: '0',
      width: '100%',
    },
  }
};
